/**
 * VGP Wholesale Info Page
 * Fetches and displays segment-specific ordering rules and FAQ.
 * BUILD092
 */
(function() {
  'use strict';

  if (typeof window.VGPProductUtils === 'undefined') {
    console.error('[VGPWholesaleInfo] VGPProductUtils not loaded. Cannot initialize.');
    return;
  }

  var Utils = window.VGPProductUtils;
  var CACHE_KEY_PREFIX = 'vgp_wholesale_info_';
  var CACHE_TTL_MS = 3 * 60 * 1000; // 3 minutes
  var activeCacheKey = CACHE_KEY_PREFIX + 'default';
  var CONFIG = {
    proxyApiUrl: '/apps/vgp-wholesale',
    endpoint: '/ordering-info',
    timeoutMs: 8000,
    debug: true
  };

  function log() {
    if (CONFIG.debug) console.log.apply(console, ['[VGPWholesaleInfo]'].concat(Array.prototype.slice.call(arguments)));
  }

  function logError() {
    console.error.apply(console, ['[VGPWholesaleInfo]'].concat(Array.prototype.slice.call(arguments)));
  }

  // DOM refs
  var pageContainer = null;
  var authGate = null;
  var content = null;
  var loading = null;
  var rulesTableEl = null;
  var movEl = null;
  var faqEl = null;
  var apiBaseUrl = '';

  /**
   * Initialize
   */
  function init() {
    pageContainer = document.querySelector('[data-vgp-wholesale-info-page]');
    if (!pageContainer) return;

    authGate = document.querySelector('[data-vgp-wi-auth-gate]');
    content = document.querySelector('[data-vgp-wi-content]');
    loading = document.querySelector('[data-vgp-wi-loading]');
    rulesTableEl = document.querySelector('[data-vgp-wi-rules-table]');
    movEl = document.querySelector('[data-vgp-wi-mov]');
    faqEl = document.querySelector('[data-vgp-wi-faq]');
    apiBaseUrl = pageContainer.getAttribute('data-vgp-direct-api-url') || '';

    if (!apiBaseUrl) {
      logError('No API URL configured.');
      return;
    }

    // Check auth
    if (!Utils.hasWholesaleJWT()) {
      log('Not authenticated, showing auth gate');
      showAuthGate();
      return;
    }

    // Load data
    loadOrderingInfo();
  }

  /**
   * Show auth gate, hide everything else
   */
  function showAuthGate() {
    if (loading) loading.style.display = 'none';
    if (content) content.style.display = 'none';
    if (authGate) authGate.style.display = 'block';
  }

  /**
   * Build API URL (always via App Proxy — endpoint requires JWT)
   */
  function buildApiUrl() {
    return CONFIG.proxyApiUrl + CONFIG.endpoint;
  }

  /**
   * Escape HTML
   */
  function esc(str) {
    return Utils.escapeHTML(str);
  }

  /**
   * Format a price value
   */
  function formatPrice(val) {
    var num = parseFloat(val);
    if (isNaN(num)) return val;
    return '$' + num.toFixed(2);
  }

  /**
   * Load ordering info from API
   */
  async function loadOrderingInfo() {
    // Hide auth gate in case it was shown before auth completed
    if (authGate) authGate.style.display = 'none';
    if (loading) loading.style.display = 'block';
    if (content) content.style.display = 'none';

    try {
      // Check cache
      var data = Utils.getCached(activeCacheKey, CACHE_TTL_MS);

      if (!data) {
        var url = buildApiUrl();
        log('Fetching:', url);

        var controller = new AbortController();
        var timeoutId = setTimeout(function() { controller.abort(); }, CONFIG.timeoutMs);

        var response;
        try {
          response = await fetch(url, {
            headers: Utils.buildAuthHeaders(),
            signal: controller.signal
          });
        } finally {
          clearTimeout(timeoutId);
        }

        if (response.status === 401) {
          log('Not authorized, showing auth gate');
          showAuthGate();
          return;
        }

        if (!response.ok) {
          var errBody = '';
          try { errBody = await response.text(); } catch(e) {}
          log('API error response:', response.status, errBody);
          throw new Error('API error: ' + response.status);
        }

        data = await response.json();

        // Scope cache key by segment name from response
        if (data.segment_name) {
          activeCacheKey = CACHE_KEY_PREFIX + data.segment_name;
        }
        Utils.setCache(activeCacheKey, data, CACHE_TTL_MS);
      }

      // Render
      renderRulesTable(data.rules || []);
      renderMOV(data.minimum_order_value);
      renderFAQ(data.rules || [], data.minimum_order_value);

      if (loading) loading.style.display = 'none';
      if (content) content.style.display = 'block';

    } catch (error) {
      if (error.name === 'AbortError') return;
      logError('Failed to load ordering info:', error.message);

      if (loading) loading.style.display = 'none';
      if (content) {
        content.style.display = 'block';
        if (rulesTableEl) {
          rulesTableEl.innerHTML = '<div class="wholesale-info-empty">Unable to load ordering information. Please try refreshing the page.</div>';
        }
      }
    }
  }

  /**
   * Render rules table
   */
  function renderRulesTable(rules) {
    if (!rulesTableEl) return;

    if (rules.length === 0) {
      rulesTableEl.innerHTML = '<div class="wholesale-info-empty">No specific ordering requirements at this time. You may order any quantity.</div>';
      return;
    }

    var html = '<table class="wholesale-info-table">';
    html += '<thead><tr>';
    html += '<th>Product Line</th>';
    html += '<th>Min per Design</th>';
    html += '<th>Min Total</th>';
    html += '<th>Case Pack Size</th>';
    html += '</tr></thead>';
    html += '<tbody>';

    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      html += '<tr>';
      html += '<td>' + esc(r.display_name) + '</td>';
      html += '<td>' + (r.min_per_variant != null ? r.min_per_variant : '<span class="no-data">&mdash;</span>') + '</td>';
      html += '<td>' + (r.min_total != null ? r.min_total : '<span class="no-data">&mdash;</span>') + '</td>';
      html += '<td>' + (r.order_increment != null ? r.order_increment : '<span class="no-data">&mdash;</span>') + '</td>';
      html += '</tr>';
    }

    html += '</tbody></table>';
    rulesTableEl.innerHTML = html;
  }

  /**
   * Render minimum order value callout
   */
  function renderMOV(mov) {
    if (!movEl) return;
    if (mov && mov > 0) {
      movEl.innerHTML = '<div class="wholesale-info-mov"><strong>Minimum Order Value:</strong> ' + formatPrice(mov) + '</div>';
      movEl.style.display = 'block';
    } else {
      movEl.style.display = 'none';
    }
  }

  /**
   * Build FAQ items — hardcoded questions, dynamic answers
   */
  function renderFAQ(rules, mov) {
    if (!faqEl) return;

    var faqItems = [];

    // Q1: How to place an order
    faqItems.push({
      q: 'How do I place a wholesale order?',
      a: 'Visit the <a href="/pages/quick-order" style="color:#00AEFF;">Quick Order</a> page to browse your full catalog. ' +
         'Select your products, choose variants (piece count), set quantities, and add to cart. ' +
         'When ready, proceed to checkout — we\'ll create an invoice for you to complete payment.'
    });

    // Q2: Case packs — dynamic based on rules
    var casePackAnswer = buildCasePackAnswer(rules);
    faqItems.push({
      q: 'What are case packs?',
      a: casePackAnswer
    });

    // Q3: Minimum order requirements — dynamic reiteration of table
    var minReqAnswer = buildMinReqAnswer(rules);
    faqItems.push({
      q: 'What are the minimum order requirements?',
      a: minReqAnswer
    });

    // Q4: MOV — only show if applicable
    if (mov && mov > 0) {
      faqItems.push({
        q: 'Is there a minimum order value?',
        a: 'Yes, all wholesale orders must meet a minimum of <strong>' + formatPrice(mov) + '</strong>. ' +
           'Your cart will show a progress bar toward this threshold so you can see how close you are.'
      });
    }

    // Q5: Pricing
    faqItems.push({
      q: 'How does pricing work?',
      a: 'As a wholesale partner, you receive special wholesale pricing that\'s lower than MSRP. ' +
         'Prices are shown on the Quick Order page and in your cart. ' +
         'Some products may have promotional pricing during active campaigns.'
    });

    // Q6: Saved carts
    faqItems.push({
      q: 'Can I save my cart for later?',
      a: 'Yes! Use the Save Cart feature to store up to 20 cart configurations. ' +
         'Saved carts are shared across your organization — any team member on your account can access them. ' +
         'This is great for setting up reorder templates.'
    });

    // Q7: Shipping
    faqItems.push({
      q: 'How does shipping work?',
      a: 'Shipping is calculated based on your account type and order size. ' +
         'Larger orders may qualify for reduced shipping rates or free shipping. ' +
         'Your shipping cost is shown at checkout before you confirm your order.'
    });

    // Q8: After ordering
    faqItems.push({
      q: 'What happens after I place an order?',
      a: 'After checkout, an invoice is created for your order. ' +
         'You\'ll receive an email with payment instructions. ' +
         'Once payment is confirmed, your order is fulfilled and shipped.'
    });

    // Q9: Validation errors
    faqItems.push({
      q: 'What if I see a validation error in my cart?',
      a: 'The cart checks all ordering rules before checkout. ' +
         'If something doesn\'t meet requirements (quantity too low, not a case pack multiple, etc.), ' +
         'you\'ll see a clear message explaining what to fix. ' +
         'Use the "Fix All" button to auto-correct quantities to the nearest valid amount.'
    });

    // Build HTML
    var html = '';
    for (var i = 0; i < faqItems.length; i++) {
      var item = faqItems[i];
      html += '<div class="wholesale-info-faq-item">';
      html += '<div class="wholesale-info-faq-q" data-vgp-wi-faq-toggle>' + esc(item.q) + '</div>';
      html += '<div class="wholesale-info-faq-a">' + item.a + '</div>';
      html += '</div>';
    }
    faqEl.innerHTML = html;

    // Attach toggle listeners
    var toggles = faqEl.querySelectorAll('[data-vgp-wi-faq-toggle]');
    for (var j = 0; j < toggles.length; j++) {
      toggles[j].addEventListener('click', function() {
        var answer = this.nextElementSibling;
        var isOpen = this.classList.contains('open');
        this.classList.toggle('open', !isOpen);
        answer.classList.toggle('open', !isOpen);
      });
    }
  }

  /**
   * Build dynamic case pack answer from rules
   */
  function buildCasePackAnswer(rules) {
    var incrementRules = rules.filter(function(r) { return r.order_increment != null; });

    if (incrementRules.length === 0) {
      return 'Products ship in case packs. Your order quantities should align with case pack sizes ' +
             'for the most efficient fulfillment. See the ordering requirements table above for specifics.';
    }

    if (incrementRules.length === 1) {
      var r = incrementRules[0];
      return esc(r.display_name) + ' ship in case packs of <strong>' + r.order_increment + ' units</strong>. ' +
             'Your order must be in multiples of ' + r.order_increment + '. ' +
             'The cart will suggest the nearest valid quantity if your order doesn\'t align.';
    }

    // Multiple rules with increments
    var parts = incrementRules.map(function(r) {
      return '<li><strong>' + esc(r.display_name) + ':</strong> ' + r.order_increment + ' units per case</li>';
    });
    return 'Products ship in case packs. Your order for each product line must be in multiples of the case pack size:<ul>' +
           parts.join('') + '</ul>' +
           'The cart will suggest the nearest valid quantity if your order doesn\'t align.';
  }

  /**
   * Build dynamic minimum requirements answer from rules
   */
  function buildMinReqAnswer(rules) {
    if (rules.length === 0) {
      return 'There are no specific minimum order requirements at this time. You may order any quantity.';
    }

    var parts = rules.map(function(r) {
      var details = [];
      if (r.min_per_variant != null) {
        var msg = r.message_min_per_variant ? esc(r.message_min_per_variant) : ('minimum ' + r.min_per_variant + ' per design');
        details.push(msg);
      }
      if (r.min_total != null) {
        var msg2 = r.message_min_total ? esc(r.message_min_total) : ('minimum ' + r.min_total + ' total');
        details.push(msg2);
      }
      if (r.order_increment != null) {
        var msg3 = r.message_increment ? esc(r.message_increment) : ('order in multiples of ' + r.order_increment);
        details.push(msg3);
      }

      if (details.length === 0) return '';
      return '<li><strong>' + esc(r.display_name) + ':</strong> ' + details.join(', ') + '</li>';
    }).filter(function(s) { return s !== ''; });

    if (parts.length === 0) {
      return 'There are no specific minimum order requirements at this time.';
    }

    return 'Each product line has its own ordering rules to ensure efficient fulfillment:<ul>' +
           parts.join('') + '</ul>' +
           'These requirements are enforced at checkout. Your cart will show any issues before you proceed.';
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(init, 150);
    });
  } else {
    setTimeout(init, 150);
  }

  // Re-initialize on auth change
  window.addEventListener('vgp:authenticated', function() {
    log('Auth event received, re-initializing');
    try {
      Object.keys(sessionStorage).forEach(function(key) {
        if (key.indexOf(CACHE_KEY_PREFIX) === 0) sessionStorage.removeItem(key);
      });
    } catch(e) {}
    activeCacheKey = CACHE_KEY_PREFIX + 'default';
    init();
  });

  log('Module loaded');
})();
